import { nextTheme, themeOf, type Theme } from '../lib/theme';

/**
 * 「화면 색」 단추(#381) — 누를 때마다 밝게 → 부드럽게 → 어둡게.
 * 머리글(`compact`)은 폭이 빠듯해(1536 에서 오른쪽 끝이 이미 화면 밖 · 10-22 실측) 아이콘만, 1800 이상(이메일이 보이는 폭)에서 「☀ 밝게」.
 * 마우스를 올리면 「화면 색: 밝게 — 누르면 부드럽게」.
 */
export default function ThemeButton({ theme, onChange, compact = false, className = '' }: {
  theme: Theme; onChange: (t: Theme) => void; compact?: boolean; className?: string;
}) {
  const cur = themeOf(theme);
  const next = themeOf(nextTheme(theme));
  return (
    <button type="button" className={`btn-ghost whitespace-nowrap ${compact ? 'px-2.5' : ''} ${className}`} onClick={() => onChange(next.id)}
            title={`화면 색: ${cur.label} — 누르면 ${next.label}`} aria-label={`화면 색 ${cur.label}, 누르면 ${next.label}`}>
      <span aria-hidden>{cur.icon}</span>
      {compact ? <span className="hidden min-[1800px]:inline">{cur.label}</span> : <span>화면 색 {cur.label}</span>}
    </button>
  );
}
